// extracted by mini-css-extract-plugin
module.exports = {"badgeText":"BadgeText_badgeText__jbbUI"};